
import apiClient from "./api";

const fetchLast12Months = () => {
     return apiClient.get('dashboard/certifications-by-type-last-12-months').then(res => res.data);
};

const fetchFinished = () => {
     return apiClient.get('dashboard/finished').then(res => res.data);
}

const fetchPending = () => {
     return apiClient.get('dashboard/pending').then(res => res.data);
}

const fetchCancelled = () => {
     return apiClient.get('dashboard/cancelled').then(res => res.data);
}

const fetchBilling = () => {
     return apiClient.get('dashboard/billing').then(res => res.data);
}

const fetchTopGaragesMonth = () => {
     return apiClient.get('dashboard/top-garages').then(res => res.data);
}

export default { fetchLast12Months, fetchFinished, fetchPending, fetchCancelled, fetchBilling, fetchTopGaragesMonth };